import { Configuration, PublicClientApplication } from "@azure/msal-browser";

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID!,
    authority: process.env.REACT_APP_AZURE_TENANT_ID
      ? `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`
      : undefined,
    redirectUri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:3000",
  } as any, // Type assertion needed due to potential undefined values
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

// Validate required configuration
export const validateAuthConfig = () => {
  const required = [
    'REACT_APP_AZURE_CLIENT_ID',
    'REACT_APP_AZURE_TENANT_ID'
  ];

  const missing = required.filter(key => !process.env[key]);

  if (missing.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missing.join(', ')}\n\n` +
      'Please set these in your .env.local file:\n' +
      missing.map(key => `${key}=your-value-here`).join('\n')
    );
  }

  if (!msalConfig.auth.clientId || !msalConfig.auth.authority) {
    throw new Error('MSAL configuration is invalid. Check your environment variables.');
  }
};

// Scopes for API access
export const loginRequest = {
  scopes: ["User.Read", "openid", "profile"],
};

// API scopes for backend access
export const apiRequest = {
  scopes: ["User.Read", "openid", "profile"],
};

// Initialize MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);